export const SectionHeading = ({
  title,
  text,
}: {
  title: string;
  text: string;
}) => {
  return (
    <div className="d-flex mb-5 flex-column align-items-left  section-header">
      <h3 className=" font-display">{title}</h3>
      <p className="font-onest col-10">{text}</p>
    </div>
  );
};
